export enum SecurityMode {
  AddSpecificAdvice = 0,
  AddGeneralRates = 1,
  UpdateSpecificAdvice = 2,
  UpdateGeneralRates = 3,
}
